import React from 'react';
import './index.scss';
import time from '../../assets/images/time.png'

const ActionHeader = (props: any) => {
    const { _promo } = props;
    return (
        <div className='c-action'>
            <div>
                <div className='c-action-top'>
                    <div className='c-action-tag'>{_promo.type}</div>
                    <div className='c-action-name'>{_promo.title}</div>
                </div>
                <div className='c-action-tips'>
                    <img className='c-action-icon' src={time} alt="" />
                    {
                        _promo.gifts && _promo.gifts.length
                            ?
                            <div className='c-action-bottom' >
                                <div className='c-action-tips-text'>{_promo.des}</div>
                            </div>
                            :
                            <div className='c-action-bottom'>
                                <div className='c-action-tips-text'>活动仅剩：</div>
                                <div className='c-action-countdown'>{_promo.des}</div>
                            </div>
                    }
                </div>
            </div>
            {
                _promo.gifts && _promo.gifts.length &&
                <div className="gift-wrap">
                    {
                        _promo.gifts.map(gift => {
                            return <img className="gift-image" src={gift.images[0].full.url} />
                        })
                    }
                </div>
            }

        </div>
    )
}

export default ActionHeader